export default class FormParam
{
	remoteClass = "gongqi.erp.gotmodel.form.remote.FormParam";
	callerFormId;
	callerMenuItemId;
	
	callerType;
	callerLookupField;
	callerKey;
	joinTableAlias;
	joinTableName;
	
	menuItemId;
	formId;
	
	paramString;
	paramObject;
	
	callerCommandArg;	//目前只有当自定义的lookup被下拉出来时，才有效
}



// WEBPACK FOOTER //
// ./src/forms/sys/remote/FormParam.js